import {
  SET_ENTITY,
  RESET_LIST_DT_STATE
} from "@/store/mutation-types";

const module = "DT_HISTORY";

const initialState = () => {
  return {
    dataHistory: [],
    dataDT: {},
  }
}

export default {
  namespaced: true,
  state: initialState(),

  // getters: {
  //   isListdataDTLoading(state) {
  //     return (
  //       !state.list.length 
  //     );
  //   },
  // },

  mutations: {
    [RESET_LIST_DT_STATE](state) {
      Object.assign(state, initialState());
    }
  },

  actions: {
    showHistory({dispatch}, nd) {
      dispatch('fetchDTHistory', nd);
    },
    closeHistory({commit}) {
      commit(
        SET_ENTITY,
        {
          module,
          entity: "dataHistory",
          value: [],
        },
        { root: true }
      );
    },
    loadDataDT ({dispatch, commit}, nd) {
      dispatch('ListDT/selectedDT', nd, {root:true})
        .then( response => {
          commit(
            SET_ENTITY,
            {
              module,
              entity: "dataDT",
              value: response,
            },
            { root: true }
          );
        }
      );
    },
    async fetchDTHistory({dispatch, commit }, nd) {
      const params = {
        nd: nd
      }
      const items = await this.$api.dcl.getHistory(params);

      dispatch ('loadDataDT', nd);
      commit(
        SET_ENTITY,
        {
          module,
          entity: "dataHistory",
          value: items,
        },
        { root: true }
      );
    },
  },
};